import appConfig from './appConfig';
import interpolate from './interpolate';
import { mergeUrlParams } from './url';

const externalRouter = {};

externalRouter.parse = function(route, options, queryParams = {}) {
  const config = appConfig.getMyConfig();
  const url = config[route] || config[`${route}Url`] || config[`${route}Template`];
  const parsedUrl = interpolate(url, options);

  return mergeUrlParams(parsedUrl, queryParams);
};

externalRouter.navigate = function(route, options, queryParams = {}) {
  window.location = this.parse(route, options, queryParams);
};

export default externalRouter;
